import {
  Avatar,
  Button,
  Card,
  DatePicker,
  Flex,
  Form,
  GetProp,
  Input,
  Select,
  Space,
  Table,
  TableProps,
  Tag,
  Typography,
  Image,
  Row,
  Col,
  Collapse,
  Radio,
} from "antd";
import {
  SearchOutlined,
  CloseOutlined,
  PlusOutlined,
  HomeOutlined,
  HomeTwoTone,
  ShopOutlined,
  CoffeeOutlined,
  SwapOutlined,
  MinusOutlined,
  UserOutlined,
  CheckOutlined,
  CalendarOutlined,
  MailOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { ColumnsType, SorterResult } from "antd/es/table/interface";
import qs from "qs";
import CommonDataTable from "../common/CommonDataTable";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faMinus,
  faUser,
  faArrowRight,
  faArrowRightLong,
  faCalendarDays,
  faEnvelope,
  faMagnifyingGlass,
} from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import CardBox from "../common/CardBox";

const { Title, Text } = Typography;

const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;

export const Dashboard = () => {
  const items = [
    {
      key: "1",
      label: (
        <>
          <Title level={4} className="font-weight-400 mt-2 mb-1">
            <FontAwesomeIcon className="iconsbg mr-1" icon={faUser} /> Profile
            Details
          </Title>
        </>
      ),
      children: <></>,
    },
    {
      key: "2",
      label: "This is panel header 2",
      children: <p>{text}</p>,
    },
    {
      key: "3",
      label: "This is panel header 3",
      children: <p>{text}</p>,
    },
  ];

  const onChange = (key: any) => {
    console.log(key);
  };

  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const setAgeSort = () => {
    setSortedInfo({
      order: "descend",
      columnKey: "age",
    });
  };
  const clearFilters = () => {
    setFilteredInfo({});
  };
  const clearAll = () => {
    setFilteredInfo({});
    setSortedInfo({});
  };

  const handleChange = (pagination: any, filters: any, sorter: any) => {
    console.log("Various parameters", pagination, filters, sorter);
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  const columns = [
    {
      title: "Agt Name",
      dataIndex: "agtName",
      key: "agtName",
    },
    {
      title: "Reference Number	",
      dataIndex: "referenceNumber",
      key: "referenceNumber",
    },
    {
      title: "Service Name",
      dataIndex: "serviceName",
      key: "serviceName",
    },
    {
      title: "Agent Reference Number",
      dataIndex: "agentReferenceNumber",
      key: "agentReferenceNumber",
    },
    {
      title: "Customer Name",
      dataIndex: "customerName",
      key: "customerName",
    },
    {
      title: "Adult",
      dataIndex: "adult",
      key: "adult",
    },
    {
      title: "Child",
      dataIndex: "child",
      key: "child",
    },
    {
      title: "Infant",
      dataIndex: "infant",
      key: "infant",
    },
    {
      title: "Booking Date",
      dataIndex: "bookingDate",
      key: "bookingDate",
    },
    {
      title: "Travel Date",
      dataIndex: "travelDate",
      key: "travelDate",
    },
    {
      title: "Cancellation Deadline",
      dataIndex: "cancellationDeadline",
      key: "cancellationDeadline",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "View Details",
      dataIndex: "viewDetails",
      key: "viewDetails",
    },
  ];

  const data = [
    {
      key: "1",
      agtName: "John Brown",
      referenceNumber: "AGT-900",
      serviceName: "New York No. 1 Lake Park",
      agentReferenceNumber: "ETMKT980990",
      customerName: "Mr. Gharju",
      adult: "2",
      child: "0",
      infant: "0",
      bookingDate: "29/02/2022",
      travelDate: "30/02/2022",
      cancellationDeadline: "cancellationDeadline",
      status: <Tag color="green">Completed</Tag>,
      viewDetails: "viewDetails",
    },
    {
      key: "1",
      agtName: "John Brown",
      referenceNumber: "AGT-900",
      serviceName: "New York No. 1 Lake Park",
      agentReferenceNumber: "ETMKT980990",
      customerName: "Mr. Gharju",
      adult: "2",
      child: "0",
      infant: "0",
      bookingDate: "29/02/2022",
      travelDate: "30/02/2022",
      cancellationDeadline: "cancellationDeadline",
      status: <Tag color="red">Rejected</Tag>,
      viewDetails: "viewDetails",
    },
  ];

  const imageOption = [
    {
      value: "all",
      label: (
        <div className="flex items-center gap-2">
          <Avatar
            style={{
              backgroundColor: "#12b8c4",
              verticalAlign: "middle",
            }}
            icon={<HomeOutlined />}
            className="mr-2"
          />
          <span>All</span>
        </div>
      ),
    },
    {
      value: "hotel",
      label: (
        <div className="flex items-center gap-2">
          <Avatar
            style={{
              backgroundColor: "#2c92df",
              verticalAlign: "middle",
            }}
            icon={<ShopOutlined />}
            className="mr-2"
          />
          <span>Hotel</span>
        </div>
      ),
    },
    {
      value: "activities",
      label: (
        <div className="flex items-center gap-2">
          <Avatar
            style={{
              backgroundColor: "#f3b711",
              verticalAlign: "middle",
            }}
            icon={<ShopOutlined />}
            className="mr-2"
          />
          <span>Activities</span>
        </div>
      ),
    },
    {
      value: "meal",
      label: (
        <div className="flex items-center gap-2">
          <Avatar
            style={{
              backgroundColor: "#fc5656",
              verticalAlign: "middle",
            }}
            icon={<CoffeeOutlined />}
            className="mr-2"
          />
          <span>Meal</span>
        </div>
      ),
    },
  ];

  return (
    <CardBox
      title={
        <Typography.Title
          level={2}
          color="danger"
          className="mb-0 mt-0 primary-color font-weight-700"
        >
          Efficient &nbsp;
          <Text type="danger" className="header-font-title">
            Dashboard
          </Text>
        </Typography.Title>
      }
    >
      <Row gutter={[16, 0]} className="mb-2">
        <Col xs={24} lg={6}>
          <Card className="card-sky border-8 border-0 box-shadow">
            <Flex>
              <div>
                <Title
                  level={5}
                  className="white-color font-weight-400 my-0 mb-1"
                >
                  Booking Completed
                </Title>
                <Title
                  level={2}
                  className="white-color font-weight-400 my-0 mb-1"
                >
                  5678
                </Title>
              </div>
              <Avatar
                className="dashboard-card-icon p-4 ml-auto"
                icon={<CalendarOutlined />}
              />
            </Flex>
            <div className="dashboard-card-footer p-2">
              <Button type="link" size="small">
                {" "}
                <Text>
                  VIEW DETAILS <FontAwesomeIcon icon={faArrowRightLong} />
                </Text>{" "}
              </Button>
            </div>
          </Card>
        </Col>
        <Col xs={24} lg={6}>
          <Card className="card-red border-8 border-0 box-shadow">
            <Flex>
              <div>
                <Title level={5} className="font-weight-400 my-0 mb-1">
                  Booking Rejected
                </Title>
                <Title level={2} className="font-weight-400 my-0 mb-1">
                  255
                </Title>
              </div>
              <Avatar
                className="dashboard-card-icon p-4 ml-auto"
                icon={<CalendarOutlined />}
              />
            </Flex>

            <div className="dashboard-card-footer p-2">
              <Button type="link" size="small">
                {" "}
                <Text>
                  VIEW DETAILS <FontAwesomeIcon icon={faArrowRightLong} />
                </Text>{" "}
              </Button>
            </div>
          </Card>
        </Col>
        <Col xs={24} lg={6}>
          <Card className="card-orange border-8 border-0 box-shadow">
            <Flex>
              <div>
                <Title level={5} className="font-weight-400 my-0 mb-1">
                  Booking Vouchered
                </Title>
                <Title level={2} className="font-weight-400 my-0">
                  2346
                </Title>
              </div>
              <Avatar
                className="dashboard-card-icon p-4 ml-auto"
                icon={<CalendarOutlined />}
              />
            </Flex>

            <div className="dashboard-card-footer p-2">
              <Button type="link" size="small">
                {" "}
                <Text>
                  VIEW DETAILS <FontAwesomeIcon icon={faArrowRightLong} />
                </Text>{" "}
              </Button>
            </div>
          </Card>
        </Col>
        <Col xs={24} lg={6}>
          <Card className="card-blue border-8 border-0 box-shadow">
            <Flex>
              <div>
                <Title level={5} className="font-weight-400 my-0">
                  Booking Done
                </Title>
                <Title level={2} className="font-weight-400 my-0">
                  780
                </Title>
              </div>
              <Avatar
                className="dashboard-card-icon p-4 ml-auto"
                icon={<CalendarOutlined />}
              />
            </Flex>

            <div className="dashboard-card-footer p-2">
              <Button type="link" size="small">
                {" "}
                <Text>
                  VIEW DETAILS <FontAwesomeIcon icon={faArrowRightLong} />
                </Text>{" "}
              </Button>
            </div>
          </Card>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card className="border-8 border-0 box-shadow">
            <Flex>
              <div>
                <Title level={2} className="font-weight-400 my-0 mb-1">
                  0
                </Title>
                <Title level={5} className="font-weight-400 my-0 mb-1">
                  Rate Plan Master
                </Title>
              </div>
              <Avatar
                className="dashboard-card-icon p-4 ml-auto"
                icon={<MailOutlined />}
              />
            </Flex>

            <div className="dashboard-card-footer p-2">
              <Button type="link" size="small">
                {" "}
                <Text>
                  VIEW DETAILS <FontAwesomeIcon icon={faArrowRightLong} />
                </Text>{" "}
              </Button>
            </div>
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card className="border-8 border-0 box-shadow">
            <Flex>
              <div>
                <Title level={2} className="font-weight-400 my-0 mb-1">
                  1661
                </Title>
                <Title level={5} className="font-weight-400 my-0 mb-1">
                  Activity Operations
                </Title>
              </div>
              <Avatar
                className="dashboard-card-icon p-4 ml-auto"
                icon={<SettingOutlined />}
              />
            </Flex>

            <div className="dashboard-card-footer p-2">
              <Button type="link" size="small">
                {" "}
                <Text>
                  VIEW DETAILS <FontAwesomeIcon icon={faArrowRightLong} />
                </Text>{" "}
              </Button>
            </div>
          </Card>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card className="border-8 border-0 box-shadow">
            <Flex justify="space-between">
              <Title level={4} className="font-weight-400 my-0 mb-1">
                Completed Bookings in 2025
              </Title>
              <Title level={4} className="font-weight-400 my-0 mb-1">
                AED 0.00
              </Title>
            </Flex>

            <div
              style={{
                display: "Flex",
                alignItems: "center",
                justifyContent: "center",
                height: "300px",
              }}
            >
              <Title level={1} className="font-weight-400 my-0 mb-1">
                <Text color="gray"> Graph will come here</Text>
              </Title>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card className="border-8 border-0 box-shadow">
            <Flex justify="space-between">
              <Title level={4} className="font-weight-400 my-0 mb-1">
                All Bookings
              </Title>
              <Title level={4} className="font-weight-400 my-0 mb-1">
                AED 0.00
              </Title>
            </Flex>

            <div
              style={{
                display: "Flex",
                alignItems: "center",
                justifyContent: "center",
                height: "300px",
              }}
            >
              <Title level={1} className="font-weight-400 my-0 mb-1">
                <Text color="gray"> Graph will come here</Text>
              </Title>
            </div>
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <Card className="border-8 border-0 box-shadow mb-4 mt-3">
            <Title level={4} className="font-weight-400 mt-2 mb-4">
              <Flex align="center" justify="start" gap={12}>
                <div className="iconsbg mr-1">
                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                </div>
                Current Booking Completed
              </Flex>
            </Title>
            <Flex justify="space-between">
              <Select
                defaultValue="all"
                options={imageOption}
                className="mb-3 w-100"
              />
            </Flex>

            <Table
              columns={columns}
              dataSource={data}
              onChange={handleChange}
              className="mt-4"
              scroll={{
                x: 800,
              }}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <Card className="border-8 border-0 box-shadow mb-4 mt-3">
            <Title level={4} className="font-weight-400 mt-2 mb-4">
              <Flex align="center" justify="start" gap={12}>
                <div className="iconsbg mr-1">
                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                </div>
                All Vouchers
              </Flex>
            </Title>
            <Flex justify="space-between">
            <Select
                defaultValue="all"
                options={imageOption}
                className="mb-3 w-100"
              />
            </Flex>

            <Table
              columns={columns}
              dataSource={data}
              onChange={handleChange}
              className="mt-4"
              scroll={{
                x: 800,
              }}
            />
          </Card>
        </Col>
      </Row>
    </CardBox>
  );
};

export default Dashboard;
